import React from 'react';
import { SvgIconProps } from '@mui/material';
import IconButton, { IconButtonProps } from '../IconButton';
import ToggleIcon from './components/ToggleIcon';

export type MUIFontIconName = string;

interface BaseToggleIconButtonProps extends Omit<IconButtonProps, 'variant' | 'color' | 'title'> {
  children: React.ReactElement<SvgIconProps> | MUIFontIconName;
  variant?: 'text' | 'outlined' | 'tonal';
  color?: 'primary' | 'secondary';
}

interface PropsWithNodeTitle extends BaseToggleIconButtonProps {
  title: React.ReactNode;
  'aria-label': string;
}

interface PropsWithStringTitle extends BaseToggleIconButtonProps {
  title: string;
}

export type ToggleIconButtonProps = PropsWithNodeTitle | PropsWithStringTitle;

const ToggleIconButton = ({
  children,
  active,
  variant,
  color,
  ...props
}: ToggleIconButtonProps) => {
  return (
    <IconButton
      {...props}
      color={color || 'secondary'}
      variant={active ? 'contained' : variant}
      aria-selected={active || undefined}
    >
      <ToggleIcon active={active}>
        {children}
      </ToggleIcon>
    </IconButton>
  );
};

export default ToggleIconButton;